import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.74999 13.76L7.16999 12.34L10.99 16.15V4H13V16.15L16.82 12.34L18.24 13.76L12 20L5.73999 13.76H5.74999Z" fill={ fill || 'currentColor' } />
    </svg>
);
